(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navigation-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncPanels = (panels) => {
      const primaryPanel = panels.querySelector(':scope > .primary-menu-panel');
      const menuPanels = Array.from(panels.querySelectorAll(':scope > .menu-panel'));
      const activeNestedPanel = panels.querySelector(':scope > .menu-panel[data-menu-nested].is-active');
      const activeParentPanel = panels.querySelector(':scope > .menu-panel:not([data-menu-nested]).is-active');
      const visiblePanel = activeNestedPanel || activeParentPanel || primaryPanel;

      panels.classList.toggle('has-active-panel', Boolean(activeParentPanel || activeNestedPanel));
      panels.classList.toggle('has-active-nested-panel', Boolean(activeNestedPanel));

      [primaryPanel, ...menuPanels].filter(Boolean).forEach((panel) => {
        const isHidden = panel !== visiblePanel;
        panel.inert = isHidden;

        if (isHidden) {
          panel.setAttribute('aria-hidden', 'true');
        } else {
          panel.removeAttribute('aria-hidden');
        }
      });

      const activeKey = visiblePanel?.dataset.menu || 'root';

      if (panels.dataset.activeMenu === activeKey) return;

      panels.dataset.activeMenu = activeKey;

      requestAnimationFrame(() => {
        const drawerContent = panels.closest('.drawer__content--nav');

        if (visiblePanel) {
          visiblePanel.scrollTop = 0;
          visiblePanel.scrollLeft = 0;
        }

        if (drawerContent) {
          drawerContent.scrollTop = 0;
          drawerContent.scrollLeft = 0;
        }
      });
    };

    const initializePanels = (panels) => {
      if (panels.dataset.panelVisibilityReady === 'true') return;

      panels.dataset.panelVisibilityReady = 'true';
      syncPanels(panels);

      const observer = new MutationObserver(() => syncPanels(panels));
      observer.observe(panels, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
      });
    };

    const initializeDrawers = (root = document) => {
      root.querySelectorAll('header-drawer .menu-panels').forEach(initializePanels);
    };

    initializeDrawers();
    document.addEventListener('shopify:section:load', (event) => initializeDrawers(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
